import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
    selector: 'app-property-details',
    templateUrl: 'property-details.html'
})
export class PropertyDetailsComponent {

    data: {
        title: string,
        description: string
    }

    constructor(@Inject(MAT_DIALOG_DATA) data: {title: string, description: string}) {
        this.data = data
    }
}
